import angular from 'angular';
import uiRouter from 'angular-ui-router';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import modal from 'angular-ui-bootstrap/src/modal';
import laborDistributionReportComponent from './labor-distribution-report.component';

let laborDistributionReportModule = angular.module('labordistributionreport', [
  uiRouter,
  modal,
  datepickerPopup,
  'chart.js'
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
  $urlRouterProvider.otherwise('/');

  $stateProvider.state('laborDistributionReport', {
    parent: 'app',
    url: '/admin/reports/labordistributionreport',
    data: {
      pageHeader: true,
      pageTitle: 'Labor Distribution Report',
      pageDesc: '',
      breadcrumbLink: 'admin.reports',
      breadcrumbText: 'View All Reports'
    },
    template: '<labordistributionreport></labordistributionreport>'
  });

})

.component('labordistributionreport', laborDistributionReportComponent);

export default laborDistributionReportModule;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/labor-distribution-report/labor-distribution-report.js